module.exports = __webpack_public_path__ + "img/健身连锁.5819f085.png";